import { useMediaQuery, useTheme } from '@material-ui/core';

export function useMobileResolution() {
  const theme = useTheme();
  const isMobileResolution = useMediaQuery(theme.breakpoints.down(720));
  return isMobileResolution;
}
